import React from "react";
import style from "../ui/Package.module.css";

function Package() {
  return <div>Package</div>;
}

export default Package;
